import { atom } from "recoil";
import { AtomKeys } from "stores/storeKeys";
/**
 * 再度メニュー状態
 */
export type NavbarStateType = {
  open: boolean;
};

export const NavbarState = atom<NavbarStateType>({
  key: AtomKeys.NAVBAR_STATE,
  default: {
    open: false,
  },
});
